/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventssearchlabel2Inputs */

const en_eventssearchlabel2 = /** @type {(inputs: Eventssearchlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search events`)
};

const de_eventssearchlabel2 = /** @type {(inputs: Eventssearchlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events durchsuchen`)
};

/**
* | output |
* | --- |
* | "Search events" |
*
* @param {Eventssearchlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventssearchlabel2 = /** @type {((inputs?: Eventssearchlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventssearchlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventssearchlabel2(inputs)
	return de_eventssearchlabel2(inputs)
});
export { eventssearchlabel2 as "eventsSearchLabel" }